<pos-app-spinner [show]=" (loading$|async )|| (loadingFetchingOrderFromJDE$ | async)"></pos-app-spinner>
<div class="pb-5">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">JOB REQUESTS</h3>
  </div>
  <div class="col m-2">
    <div class="row my-2">
      <div class="col-12 d-flex justify-content-between flex-wrap" style="background-color: rgb(236, 234, 234)">
        <ul class="nav nav-tabs w-100">
          <li class="nav-item d-flex justify-content-start" *ngFor="let nav of notificationNavs; let i = index">
            <a
              class="nav-link"
              [ngClass]="{ active: jobRequestActiveNavIndex === i, inactive: jobRequestActiveNavIndex !== i }"
              [style.color]="jobRequestActiveNavIndex === i ? 'black' : 'grey'"
              (click)="setActiveNavClick(i)"
              href="javascript:void(0)"
            >
              <span *ngIf="nav.badgeCount > 0" class="badge bg-primary me-2">{{ nav.badgeCount }}</span>
              {{ nav.label }}
            </a>
          </li>
          <li class="nav-item ms-auto">
            <div class="d-flex">
              <div class="d-flex justify-content-end align-items-center w-100">
                <div>
                  <input type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Quick filter..." />
                </div>
                <div *ngIf="isClickAndCollect" style="margin-top: -5px">
                  <button type="button" class="btn btn-secondary mt-2 w-100" (click)="isShowAdvanceFilter = !isShowAdvanceFilter">
                    Advanced Filters
                    <mat-icon style="height: 20px; width: 20px">{{ isShowAdvanceFilter ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--please add a header section where I can filter by order where I am the sales person and also filter by the different statuses (Print pick, accept order, notify customer (should have both "ECOM NOTIFYING CUSTOMER" and "CUSTOMER NOTIFIED") and mark order as collected.  -->
    <div *ngIf="isShowAdvanceFilter" class="row my-2">
      <div class="col-12">
        <div class="card p-3 mb-3">
          <label class="me-3 mb-2">FILTER BY:</label>
          <div class="d-flex flex-wrap align-items-center w-100">
            <div class="form-check me-3">
              <input class="form-check-input" type="checkbox" id="assignedToMe" [(ngModel)]="filterAssignedToMe" (change)="onAssignedToMeChange()" />
              <label class="form-check-label text-uppercase" for="assignedToMe">Assigned to me</label>
            </div>

            <div *ngFor="let status of clickAndCollectStatus" class="form-check me-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="status_{{ status.statusCode }}"
                [checked]="isStatusSelected(status.statusCode)"
                (change)="toggleStatusFilter(status.statusCode)"
              />
              <label class="form-check-label text-uppercase" for="status_{{ status.statusCode }}">{{ status.statusDescription }}</label>
            </div>

            <div class="ms-auto d-flex gap-2">
              <button type="button" class="btn btn-outline-secondary text-uppercase" (click)="resetFilters()">Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="jobRequestActiveNavIndex === 4" class="row my-2">
      <div class="col-5">
        <!-- Add a dropdown for trade show order  -->
        <div class="d-flex align-items-center w-100">
          <label for="tradeShowSelect" class="me-2 mb-0">Trade Show</label>
          <ng-select class="flex-grow-1" id="tradeShowSelect" [(ngModel)]="selectedShow" (change)="setShowCode($event)">
            <ng-option *ngFor="let show of customerShowList" [value]="show.showCode">
              {{ show.showDescription }} ({{ show.startDate }} - {{ show.endDate }})
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-5">
        <!-- Add a dropdown for  show order type  -->
        <div class="d-flex align-items-center w-100">
          <label for="showOrderTypeSelect" class="me-2 mb-0">Order Type(s)</label>
          <ng-select
            id="showOrderTypeSelect"
            [(ngModel)]="selectedShowOrderType"
            placeholder="Select Show Order Type(s)"
            [items]="[
              { OrderTypeCode: 'SO', OrderTypeDescription: 'Show Order' },
              { OrderTypeCode: 'SQ', OrderTypeDescription: 'Show Quote' },
            ]"
            [multiple]="true"
            bindLabel="OrderTypeDescription"
            bindValue="OrderTypeCode"
            [searchable]="true"
            class="flex-grow-1"
          >
          </ng-select>
        </div>
      </div>
      <!-- Add Search button -->
      <div class="col-2 d-flex justify-content-start">
        <button type="button" class="btn" [disabled]="!selectedShow || !selectedShowOrderType.length" (click)="applyTradeShowOrderSearch()">
          Search
        </button>
      </div>
    </div>
    <div *ngIf="!showTradeShowOrderListMenuOnly">
      <ag-grid-angular
        #agGrid
        class="ag-theme-balham datagrid"
        [rowData]="filteredRowData"
        [context]="context"
        [frameworkComponents]="frameworkComponents"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [domLayout]="'autoHeight'"
        [pagination]="true"
        [paginationPageSize]="20"
        [quickFilterText]="searchValue"
      ></ag-grid-angular>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading text-uppercase" id="modal-basic-title">
      {{
        isShowOrderAttachment
          ? 'ORDER ATTACHMENT'
          : isShowSalesPersonSelector
            ? 'Assign Salesperson for this ' + (orderDetails?.orderType === 'SE' ? 'Click and Collect' : 'E-Commerce') + ' Order'
            : ''
      }}
    </h3>
  </div>
  <div *ngIf="isShowOrderAttachment">
    <div class="modal-body">
      <pos-app-attachment-files-notes
        [preloadAttachments]="allAttachments"
        [entityId]="entityId"
        [entityType]="entityType"
        (reloadedAttachments)="loadAllAttachments($event)"
        (closeActiveModal)="handleCloseAttachmentModel($event)"
        [orderDetails]="orderDetails"
      ></pos-app-attachment-files-notes>
    </div>
  </div>
  <div *ngIf="isShowSalesPersonSelector">
    <div class="modal-body">
      <pos-app-lib-customer-order-salesperson-selector
        [currentSalesPerson]="orderDetails?.salesPerson || orderDetails?.salesperson"
        [orderNumber]="orderDetails?.orderNumber"
        [orderType]="orderDetails?.orderType"
        [JDEOrderType]="orderDetails?.JDEOrderType"
        [JDECompany]="orderDetails?.JDECompany"
        [salesPeopleList]="salesPeopleList"
        (reloadData)="reloadData()"
        (closeActiveModal)="closeModal()"
        [isClickAndCollect]="isClickAndCollect"
        [isEcomQuote]="isEcomQuote"
      ></pos-app-lib-customer-order-salesperson-selector>
    </div>
  </div>
</ng-template>
